import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
//
import CustomCursor from "./components/CustomCursor";
import InteractiveBackground from "./components/InteractiveBackground";

import { useEffect } from "react";
import Home from "./pages/home";
import StartJourney from "./components/StartJourney";
import Plans from "./components/Plans";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";

const AnimatedRoutes = () => {
  const location = useLocation();

  // Scroll to top on route change (optional but useful)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <AnimatePresence mode="wait">
      <CustomCursor />
      <InteractiveBackground />

      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetails />} />

        <Route path="/startjourney" element={<StartJourney />} />
        <Route path="/plans" element={<Plans />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <AnimatedRoutes />
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
